import "./vehicle-tile.scss";

import React from "react";
import { Link } from "gatsby";
import classNames from "classnames";
import { addSpaceInNumbers } from "../../utils";

const VehicleTile = ({
	thumbnail,
	name,
	price,
	discountPrice,
	discount,
	label,
	labelColor,
	labelName,
	used,
	type,
	url,
}) => {
	return (
		<div
			className={classNames(`vehicle-tile`, {
				[`vehicle-tile--used`]: used === "used",
			})}
		>
			<div
				className="vehicle-tile__thumbnail"
				style={{ backgroundImage: `url(${thumbnail})` }}
			>
				{label || used === "used" ? (
					<div
						className="vehicle-tile__label"
						style={{
							backgroundColor:
								used === "used" ? "C59B6D" : labelColor,
						}}
					>
						{used === "used" ? "Używane" : labelName}
					</div>
				) : (
					""
				)}
			</div>
			<div className="vehicle-tile__type">
				{type === "przyczepa"
					? "Przyczepa"
					: type === "kampervan"
					? "Kamper-van"
					: type === "polintegra"
					? "Pół-integra"
					: type === "alkowy"
					? "Alkowa"
					: "Integra"}
			</div>
			<div className="vehicle-tile__name">{name}</div>
			<div className="vehicle-tile__price-container">
				{discount ? (
					<div className="vehicle-tile__price">
						{addSpaceInNumbers(discountPrice)} PLN{" "}
						<span>{price} PLN</span>
					</div>
				) : (
					<div className="vehicle-tile__price">
						{addSpaceInNumbers(price)} PLN
					</div>
				)}
			</div>
			<div className="vehicle-tile__location">Elcamp RV (Kraków)</div>
			<Link to={url} className="btn btn--rounded vehicle-tile__btn">
				Sprawdź!
			</Link>
		</div>
	);
};

export default VehicleTile;
